<template>
  <div id="dashboard-page">
    <b-card class="mb-5">
      <b-row>
        <b-col md="10">
          <h3>{{$route.name}}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item><router-link to="/vehicle">Vehicle Dashboard</router-link></b-breadcrumb-item>
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <!-- <b-col md="2 mt-3">
          <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
        </b-col> -->
      </b-row>
      <div class="border-bottom mb-5"></div>
      <!-- <b-row>
        <b-col md="12">
          <b-row class="mb-3">
            <b-col md="3">
              <b-form-input :placeholder="'Search By Plate Number'" v-model="tableFilter.plate" customQueryParamName="search" />
            </b-col>
          </b-row>
        </b-col>  
      </b-row> -->
      <paginated-table ref="dataTable" :can-delete="false" :can-show="true" :can-show-route-path="'#/vehicle/service-detail'" :can-edit-modal="false" :can-edit="false" :can-reject="false" :can-approve="false" :can-paid="false" :data-url="apiUrl.service" :data-key="dataKey" :data-columns="columns" :data-params="['plate']">
      </paginated-table>
      <b-button class="mt-3" @click="goBack" variant="secondary"><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button>
    </b-card>
  </div>
</template>

<script>
  import PaginatedTable from '@/components/PaginatedTable'
  export default {
    components: {
      PaginatedTable
    },
    data () {
      return {
        dataKey: 'vehicleBillInfo',
        apiUrl: {
          service: window.AppConfig.apiUrl + 'vehicle-bill-info?type=Service&status=New',
          exportServices: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        columns: [
            // {
            //   label: 'Bill Number',
            //   key: 'billNumber',
            //   sortable: false
            // },
            {
              key: 'vehiclePlate',
              label: 'Plate',
              sortable: false
            },
            {
              key: 'issuedBy',
              label: 'Issued By',
              sortable: false
            },
            {
              key: 'createdAtType',
              label: 'Issued Date',
              sortable: false
            },
            {
              key: 'typeDate',
              label: 'Service Date',
              sortable: false
            },
            {
              key: 'amounts',
              label: 'Amount',
              sortable: false
            },
            {
              key: 'paidDateVehicle',
              label: 'Paid Date',
              sortable: false
            },
            {
              key: 'notes',
              label: 'Note',
              sortable: false
            },
            {
              key: 'statusType',
              label: 'Status',
              sortable: false
            },
            {
              key: 'actions',
              label: '',
              sortable: false
            }
        ],
        tableFilter: {
          plate: this.$route.query.plate
        }
      }
    },
    watch: {
      'tableFilter.plate'() {
        this.doFilter()
      }
    },
    methods: {
      doFilter () {
        this.tableFilter.plate = this.tableFilter.plate
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      doExportToExcel () {
        let url = this.apiUrl.exportServices + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Service'
        
        window.open(url)
      },
      goBack () {
        window.goBack(this)
      },
    }
  }
</script>